(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("karcherActiveAlarmsService", karcherActiveAlarmsService);

  /** @ngInject */
  function karcherActiveAlarmsService() {
    this.checkFacilityStatus = function(alarms, facilities) {
      for (var i = 0; i < facilities.length; i++) {
        for (var j = 0; j < alarms.length; j++) {
          if (facilities[i].pointId === alarms[j].facilityId) {
            facilities[i].facilityId = alarms[j].facilityId;
            facilities[i].facilityAlarm =
              alarms[j].karcherFault.washFacilityStatus === "ALARM";
            facilities[i].facilityWarning =
              alarms[j].karcherFault.washFacilityStatus === "WARNING";
            if (alarms[j].karcherFault.washFacilityStatus === "ALARM") {
              break;
            }
          }
        }
      }
      return facilities;
    };

    this.mapFacilityNameToActiveAlarmList = function(
      karcherFacilities,
      alarms
    ) {
      for (var i = 0; i < karcherFacilities.length; i++) {
        for (var j = 0; j < alarms.length; j++) {
          if (karcherFacilities[i].point.id === alarms[j].facilityId) {
            alarms[j].facilityName = karcherFacilities[i].point.name;
          }
        }
      }
      return alarms;
    };

    this.checkDeviceStatus = function(alarms, facilities) {
      for (var i = 0; i < alarms.length; i++) {
        for (var j = 0; j < facilities.boxes.length; j++) {
          for (var k = 0; k < facilities.vacuums.length; k++) {
            switch (alarms[i].boxIds.length) {
              case 1:
                if (alarms[i].boxIds[0] === facilities.boxes[j].pointId) {
                  facilities.boxes[j].alarmStatus =
                    alarms[i].karcherFault.washBayStatus;
                }
                break;
              case 0:
                break;
              default:
                if (
                    facilities.boxes[j].alarmStatus === "ALARM"
                ) {
                  break;
                }
                facilities.boxes[j].alarmStatus =
                  alarms[i].karcherFault.washBayStatus;
                break;
            }
            switch (alarms[i].vacuumIds.length) {
              case 1:
                if (alarms[i].vacuumIds[0] === facilities.vacuums[k].pointId) {
                  facilities.vacuums[k].alarmStatus =
                    alarms[i].karcherFault.vacuumStatus;
                }
                break;
              case 0:
                break;
              default:
                if (
                    facilities.vacuums[k].alarmStatus === "ALARM"
                ) {
                  break;
                }
                facilities.vacuums[k].alarmStatus =
                  alarms[i].karcherFault.vacuumStatus;
                break;
            }
          }
        }
      }
      return facilities;
    };
  }
})();
